// extracted by mini-css-extract-plugin
export default {"root":"form-sub-section_root__2DqqE"};